import { Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const TableSkeleton = () => {
  return (
    <Table className={styles['table__skeleton']} data-testid="table-role__skeleton">
      <Thead>
        <Tr>
          <Th className={styles['skeleton__head']} width="250px">
            <Flex justifyContent="space-between">
              <SkeletonComponent height="21px" width="60%" />
              <SkeletonComponent height="21px" width="21px" />
            </Flex>
          </Th>
          <Th className={styles['skeleton__head']}>
            <SkeletonComponent height="21px" width="30%" />
          </Th>
          <Th width="194px" className={styles['skeleton__head']}>
            <Flex justifyContent="center">
              <SkeletonComponent height="21px" width="50%" />
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4, 5, 6, 7, 8]}
          render={(num) => {
            return (
              <Tr key={num}>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>

                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="21px" width="90%" mb="2px" />
                </Td>

                <Td className={styles['skeleton__column']}>
                  <Flex gap="10px" justifyContent="center">
                    <SkeletonComponent height="42px" width="42px" borderRadius="16px" />
                    <SkeletonComponent height="42px" width="42px" borderRadius="8px" />
                  </Flex>
                </Td>
              </Tr>
            );
          }}
        />
      </Tbody>
    </Table>
  );
};

export default TableSkeleton;
